import { clsx } from 'clsx';

import CustomActionKanbanCard from '../../components/common/custom-action-kanban-card';

import useStyles from './CancelKanbanCard.styles';

function CancelKanbanCard(props) {
  const {
    classes = {},
    onClickCard,
    order = {},
    showChipOfBundle = false,
    totalStores,
  } = props;

  const _classes = useStyles();

  return (
    <CustomActionKanbanCard
      classes={{ root: clsx(_classes.root, classes?.root) }}
      onClick={() => {
        onClickCard(order.id);
      }}
      storeName={totalStores > 1 ? order.store_name : null}
      orderID={order.id}
      order={order}
      showChipOfBundle={showChipOfBundle}
      showAuditableChip={order.is_auditable}
    />
  );
}

export default CancelKanbanCard;
